import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8ychefr6e: FaireProductEntity = {
  token: "p_g8ychefr6e",
  type: "product",
  name: "Body Serum",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/72a9f5426b8794a1bcb5992d89470a9e946a4db4549460533878ec9ab2b94a1b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9bd702bbe57ccf9649a3b72a742b45ebf7d87b6d7855d290f707bd2f39c63ba.jpeg",
    "https://cdn.faire.com/fastly/29cc1ef0527bc674a371b475bb42bb3eec2d1684fbeedac4d91c30198281395d.jpeg",
    "https://cdn.faire.com/fastly/a55a27cb0672fa0c89d951b41f59fcb35d97680d3705096936b35ce225436f47.jpeg",
    "https://cdn.faire.com/fastly/c5c7ec94378b83f440858eabf6c779ed393869de67a6b45d2fcb4a1501800249.jpeg",
    "https://cdn.faire.com/fastly/319cf4e4465a85878bab1e8dec4a9e03db5a9ae1fe208c809239aee60c1cc828.jpeg",
    "https://cdn.faire.com/fastly/e8bbb1d7db615869666d2a38f5dbf57b2bc303825152adace43fb2270cbe15fc.jpeg",
  ],
  priceDollars: 20.65,
  description:
    "A creamy, lightweight serum that restores calm, radiance, and hydration while supporting visibly firmer skin. This high-performance body formula blends Peptides, Niacinamide, and Phyto Collagen to strengthen the skin barrier, while adaptogens and Beta-Caryophyllene—a terpene that interacts with the body’s cannabinoid pathways—help ease stress, grounding both skin and senses. Use alone or layer under one of our two scented body crèmes. Fragrance-free, pH-balanced, and dermatologist-tested.\n\n",
  tags: [],
  msrpDollars: 59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:36.722Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
